import { render, staticRenderFns } from "./zhengfuyunForm.vue?vue&type=template&id=59787dd4&scoped=true"
import script from "./zhengfuyunForm.vue?vue&type=script&lang=js"
export * from "./zhengfuyunForm.vue?vue&type=script&lang=js"
import style0 from "./zhengfuyunForm.vue?vue&type=style&index=0&id=59787dd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59787dd4",
  null
  
)

export default component.exports